(function() { window.GUID_868a3667_97c6_4609_a264_03df32423a3b = { getGuid: function() { return "868a3667-97c6-4609-a264-03df32423a3b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class SupportFix {
                /** Call this function to fix 'requestAnimationFrame' and 'cancelAnimationFrame' vendors and not supported devices*/
                static fixRequestAnimationFrame() {
                    if (!this.fixRequestAnimationFrameAplied) {
                        this.fixRequestAnimationFrameAplied = true;
                        if (!window.requestAnimationFrame) {
                            window.requestAnimationFrame = (function () {
                                return window.webkitRequestAnimationFrame ||
                                    window.mozRequestAnimationFrame || // comment out if FF4 is slow (it caps framerate at ~30fps: https://bugzilla.mozilla.org/show_bug.cgi?id=630127)
                                    window.oRequestAnimationFrame ||
                                    window.msRequestAnimationFrame ||
                                    function (/* function FrameRequestCallback */ callback, /* DOMElement Element */ element) {
                                        return window.setTimeout(callback, 1000 / 60); //60 fps
                                    };
                            })();
                        }
                        if (!window.cancelAnimationFrame)
                            window.cancelAnimationFrame =
                                window['webkitCancelAnimationFrame'] || window['webkitCancelRequestAnimationFrame'] ||
                                    window['mozCancelAnimationFrame'] || window['mozCancelRequestAnimationFrame'] || function (id) { clearTimeout(id); };
                    }
                }
            }
            SupportFix.fixRequestAnimationFrameAplied = false;
            ImageCropperAddons.SupportFix = SupportFix;
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-supportFix.pre.js.map
